import { firebaseDB } from '@/config/firebaseConfig'

const state = {
  isLoading: true,
  productList: [],
  productCategories: [],
  gallery: []
}

const mutations = {
  'ADD_URL_GALLERY' (state, url) {
    state.gallery.push({ url: url })
  },
  'CLEAR_PRODUCTS' (state) {
    state.productList = []
    state.gallery = []
  },
  'UPDATE_PRODUCT_LIST' (state, productList) {
    state.productList = productList
    state.isLoading = false
  },
  'UPDATE_PRODUCT_GALLERY' (state, gallery) {
    state.gallery = gallery
    state.isLoading = false
  },
  'UPDATE_PRODUCTCATEGORY_LIST' (state, productCategories) {
    state.productCategories = productCategories
  }

}

const actions = {
  async getProductList ({ commit, getters }) {
    const shopRef = firebaseDB().ref('stores/' + getters.shopId)
    return shopRef.child('products').on('value', products => {
      const myProducts = []
      if (products.exists() && products.val().length > 0) {
        products.forEach(element => {
          myProducts.push({ key: element.key, ...element.val() })
        })
        let productCategories = []
        products.val().forEach((product) => {
          if (typeof product.category !== 'undefined' && !productCategories.includes(product.category)) {
            productCategories.push(product.category)
          }
        })
        commit('UPDATE_PRODUCTCATEGORY_LIST', productCategories)
      }
      commit('UPDATE_PRODUCT_LIST', myProducts.sort((a, b) => (a.title < b.title ? -1 : 1)))
    })
  },
  getProductGallery ({ commit, getters }) {
    return firebaseDB().ref(`storeAdmin/${getters.shopId}/productImages`).once('value', productImages => {
      if (productImages.val()) {
        commit('UPDATE_PRODUCT_GALLERY', productImages.val())
      }
    })
  },
  updateGallery ({ commit, getters }, gallery) {
    // return firebaseDB().ref(`/orders/${getters.shopId}/${data.customerId}/${data.orderId}`).update({ paid: data.paid })
    return firebaseDB().ref(`storeAdmin/${getters.shopId}/productImages`).set(gallery)
  },
  addProductCategory  ({ commit, state }, tag) {
    let newArr = state.productCategories
    newArr.push(tag)
    commit('UPDATE_PRODUCTCATEGORY_LIST', newArr)
  }
}

const getters = {
  gallery: state => state.gallery,
  products: state => state.productList,
  productCategories: state => state.productCategories,
  isProductLoading: state => state.isLoading
}

export default {
  state,
  mutations,
  actions,
  getters
}
